import React from 'react'
import './Home.css'
import Banner from './Banner/Banner'
import Products from './Pages/Products'
import Gallery from './Pages/Gallery'
import About from './Pages/About'
import Services from './Pages/Services'
import Contact from './Pages/Contact'
import Footer from './Footer'
import Choose from './Pages/Choose'
import Testimonial from './Pages/Testimonial'
import Stats from './Pages/Stats'
import Faq from './Pages/Faq'
import Info from './Pages/Info'
import Infotow from './Pages/Infotow'
import Barcode from './Pages/Barcode'
import { Helmet } from 'react-helmet-async'
import SeoFooter from './Pages/SeoFooter'
import ReviewPage from './Pages/ReviewPage'

const Home = () => {
  return (
    <main className="home-page">

<Helmet>
  <title>Star Aluminium Works | Premium Aluminium Experts</title>
  <meta name="description" content="Premium aluminium windows, doors, glass work, partitions, and fabrication services across Uttar Pradesh with expert installation." />
</Helmet>

<ReviewPage/>
  
<div>
  <Products/>
</div>
      <div>
        <Info />
      </div>

      <div id="services">
        <Services />
      </div>
      <div>
        <Stats />
      </div>
      <div>
        <Infotow />
      </div>

      <div>
        <Choose />
      </div>
      <div>
        <Testimonial />
      </div>

      <div id="gallery">
        <Gallery />
      </div>

      <div id="about">
        <About />
      </div>
     

      <div id="contact">
        <Contact />
      </div>
      <div>
        <Faq />
      </div>
 

    </main>
  )
}

export default Home
